import Reveal from "./Reveal";
import { channels } from "@/mocks/data";

export default function Channels() {
  return (
    <section id="channels" className="scroll-mt-24" aria-label="热门频道">
      <div className="flex items-center justify-between">
        <h2 className="flex items-center gap-2 font-heading text-2xl font-bold text-foreground-900">
          <i className="ri-grid-fill text-accent-600" />
          热门频道
        </h2>
        <a
          href="#home"
          className="hidden items-center gap-1 whitespace-nowrap text-xs font-semibold text-primary-600 hover:text-primary-700 sm:inline-flex"
        >
          回到正在发生
          <i className="ri-arrow-right-up-line" />
        </a>
      </div>
      <p className="mt-1.5 text-sm text-foreground-500">
        按栏目归类追踪，文娱、影视、音乐、科技、直播、生活一站式看全。
      </p>

      <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {channels.map((c, i) => (
          <Reveal key={c.id} delay={(i % 3) * 80}>
            <article className="flex h-full flex-col overflow-hidden rounded-2xl border border-background-200/70 bg-background-50 transition-colors hover:border-accent-200">
              <div className="relative h-36 w-full overflow-hidden md:h-40">
                <img
                  src={c.img}
                  alt={c.imgAlt}
                  className="h-full w-full object-cover object-top transition-transform duration-500 hover:scale-105"
                  width={640}
                  height={420}
                />
                <span className="absolute right-3 top-3 inline-flex items-center gap-1 rounded bg-foreground-950/55 px-2 py-1 text-[11px] font-semibold text-background-50 backdrop-blur-sm">
                  <i className="ri-fire-fill text-primary-400" />
                  {c.hot}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4">
                <div className="flex items-center justify-between">
                  <h3 className="font-heading text-lg font-bold text-foreground-900">{c.name}</h3>
                  <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                    <i className="ri-arrow-right-up-line" />
                  </span>
                </div>
                <p className="mt-0.5 text-xs text-foreground-500">{c.desc}</p>
                <ul className="mt-3 space-y-2 border-t border-background-100 pt-3">
                  {c.items.map((it) => (
                    <li key={it.title}>
                      <a
                        href="#home"
                        className="group flex items-start justify-between gap-3 text-sm"
                      >
                        <span className="line-clamp-1 font-medium text-foreground-700 group-hover:text-primary-700">
                          {it.title}
                        </span>
                        <span className="shrink-0 text-[11px] text-foreground-400">{it.time}</span>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </section>
  );
}